module.exports = __webpack_public_path__ + "img/border_LeftArrow2.36307db1.svg";